import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

export default function Header({ authenticated, onLock, navItems}) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="fixed top-0 left-0 w-full p-6 md:p-8 flex justify-between items-start z-40 pointer-events-none mix-blend-multiply">
      <div className={`transition-all duration-300 ${isScrolled ? "blur-sm" : ""}`}>
        <h1 className="font-display text-xl font-bold tracking-tight">ODITI Admin</h1>
        <div className="flex items-center gap-2 mt-1">
          <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
          <p className="text-sm font-mono uppercase tracking-widest">System Online</p>
        </div>
      </div>

      <div className="pointer-events-auto absolute left-1/2 -translate-x-1/2 top-6 pt-6 flex gap-6">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className="font-mono text-sm uppercase text-black no-underline"
          >
            {({ isActive }) => (
              <>
                <span className={`transition-opacity duration-300 ${isActive ? "opacity-100" : "opacity-0"}`}>
                  {"[ "} 
                </span>
                {item.label}
                <span className={`transition-opacity duration-300 ${isActive ? "opacity-100" : "opacity-0"}`}>
                  {" ]"}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>

      {authenticated && (
        <div className={`pointer-events-auto transition-all duration-300 ${isScrolled ? "blur-sm" : ""}`}>
          <button
            onClick={onLock}
            className="font-mono text-sm uppercase border-b border-transparent hover:border-black transition-all"
          >
            [ Lock ]
          </button>
        </div>
      )}
    </header>
  );
}